import { render, staticRenderFns } from "./OrganizationDialog.vue?vue&type=template&id=37848e14&"
import script from "./OrganizationDialog.vue?vue&type=script&lang=js&"
export * from "./OrganizationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports